module.exports = __webpack_public_path__ + "img/betamount_icon.6284d46c.svg";